export default (count: number | string) => String(+count).split('.')[0].replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 ') + (String(count).split('.')[1] ? `.${String(count).split('.')[1]}` : '');
